var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-input',{staticClass:"search-bar controll-margin",attrs:{"placeholder":_vm.placeholder,"prefix-icon":"el-icon-search","clearable":""},on:{"change":_vm.onChange},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})
}
var staticRenderFns = []

export { render, staticRenderFns }